import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Facturas from './pages/Facturas';
import Clientes from './pages/Clientes';
import Pagos from './pages/Pagos';
import Furgones from './pages/Furgones';
import Reportes from './pages/Reportes';
import Auditoria from './pages/Auditoria';
import Usuarios from './pages/Usuarios';
import Layout from './components/Layout';

function App() {
  const [usuario, setUsuario] = useState(null);

  useEffect(() => {
    const u = localStorage.getItem('usuario');
    if (u) setUsuario(JSON.parse(u));
  }, []);

  const handleLogin = (u) => {
    setUsuario(u);
    localStorage.setItem('usuario', JSON.stringify(u));
  };

  const handleLogout = () => {
    setUsuario(null);
    localStorage.removeItem('usuario');
    localStorage.removeItem('token');
  };

  const isResetPasswordRoute = window.location.pathname === '/reset-password';

  if (isResetPasswordRoute) {
    return <ResetPassword />;
  }

  if (!usuario) return <Login onLogin={handleLogin} />;

  const isEmpleado = usuario.rol === 'empleado';

  return (
    <Router>
      <Layout usuario={usuario} onLogout={handleLogout}>
        <Routes>
          <Route path="/" element={isEmpleado ? <Navigate to="/facturas" /> : <Dashboard usuario={usuario} />} />
          <Route path="/facturas" element={<Facturas />} />
          <Route path="/clientes" element={<Clientes />} />
          <Route path="/furgones" element={<Furgones />} />
          <Route path="/auditoria" element={<Auditoria />} />
          {!isEmpleado && <Route path="/pagos" element={<Pagos />} />}
          {!isEmpleado && <Route path="/reportes" element={<Reportes />} />}
          {!isEmpleado && <Route path="/usuarios" element={<Usuarios />} />}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;